import React from "react";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeCardForm from "./StripeCardForm";
import { Button, ButtonProps } from "antd";
import appConfig from "@/utils/config";
import { useModalStore } from "@/hooks/useModalStore";
// 初始化 Stripe
const stripePromise = loadStripe(appConfig["stripe_public_key"]);

const ModalPaymentBoundCard: React.FC<{}> = () => {
  const { showModalPaymentBoundCard, setShowModalPaymentBoundCard } = useModalStore();

  const handleClose = () => setShowModalPaymentBoundCard(false);

  return (
    <Elements stripe={stripePromise}>
      <StripeCardForm visible={showModalPaymentBoundCard} onClose={handleClose} />
    </Elements>
  );
};

export default ModalPaymentBoundCard;

export const ModalPaymentBoundCardButton: React.FC<{
  buttonName?: string;
  buttonProps?: ButtonProps;
  nativeButton?: boolean;
}> = ({ buttonName = "Next", buttonProps, nativeButton = false }) => {
  const { setShowModalPaymentBoundCard } = useModalStore();

  if (nativeButton) {
    return (
      <button
        type="button"
        className={buttonProps?.className}
        onClick={() => setShowModalPaymentBoundCard(true)}
      >
        {buttonName}
      </button>
    );
  }

  return (
    <Button
      size="small"
      type="default"
      style={{ width: "110px" }}
      onClick={() => setShowModalPaymentBoundCard(true)}
      {...buttonProps}
    >
      {buttonName}
    </Button>
  );
};
